import Button from 'components/Form/Button';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { POST } from 'services/api';
import styled from 'styled-components';

const JsonNode = ({ label, value }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isExpandable = typeof value === 'object' && value !== null;

  const renderValue = (val) => {
    if (typeof val === 'string') return <JsonString>"{val}"</JsonString>;
    if (typeof val === 'number') return <JsonNumber>{val}</JsonNumber>;
    if (typeof val === 'boolean')
      return <JsonBoolean>{String(val)}</JsonBoolean>;
    if (val === null) return <JsonNull>null</JsonNull>;
    return <JsonDefault>{String(val)}</JsonDefault>;
  };

  const renderContent = () => {
    if (isExpandable) {
      return Array.isArray(value) ? (
        <JsonArrayContainer>
          {value.map((item, index) => (
            <JsonNode key={index} label={index} value={item} />
          ))}
        </JsonArrayContainer>
      ) : (
        <JsonObjectContainer>
          {Object.entries(value).map(([key, val]) => (
            <JsonNode key={key} label={key} value={val} />
          ))}
        </JsonObjectContainer>
      );
    }
    return null;
  };

  return (
    <JsonLine>
      <LineHeader>
        {isExpandable ? (
          <ExpandButton onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? '▼' : '►'}
          </ExpandButton>
        ) : (
          <Spacer />
        )}
        <JsonLabel>{label}:</JsonLabel>
        {isExpandable ? (
          <JsonType>
            {Array.isArray(value)
              ? `[${value.length}]`
              : `{${Object.keys(value).length}}`}
          </JsonType>
        ) : (
          renderValue(value)
        )}
      </LineHeader>
      {isOpen && renderContent()}
    </JsonLine>
  );
};

const ModalAnaliseJulia = ({ julia_fatura, onClose, reloadContent }) => {
  const [unidade, setUnidade] = useState('');
  const [concessionaria, setconcessionaria] = useState('');
  const [cep, setCep] = useState('');
  const [cepProjeto, setCepProjeto] = useState('');
  const [multaAtraso, setMultaAtraso] = useState('Não');
  const [avisodecorte, setAvisodecorte] = useState('Não');
  const [totalconsumo, setTotalconsumo] = useState('');
  const [nome, setNome] = useState('Não');
  const [cepigual, setCepigual] = useState('nao');
  const [hasInvoice, setHasInvoice] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (julia_fatura) {
      setconcessionaria(julia_fatura.concessionaria ?? '');
      setUnidade(julia_fatura.unidade ?? '');
      setCep(julia_fatura.cep ?? '');
      setMultaAtraso(julia_fatura.multaAtraso ?? 'Não');
      setAvisodecorte(julia_fatura.avisodecorte ?? 'Não');
      setTotalconsumo(julia_fatura.totalconsumo ?? '');
      setNome(julia_fatura.nome ?? 'Não');
      setHasInvoice(true);
      const cepInstalacao = julia_fatura.cep_instalacao ?? '';
      setCepProjeto(cepInstalacao.replace(/^(\d{5})(\d{3})$/, '$1-$2'));
      // Compare cep and cep_instalacao (removing hyphens for comparison)
      const cepSemHifen = (julia_fatura.cep ?? '').replace('-', '');
      const cepInstalacaoSemHifen = cepInstalacao.replace('-', '');
      setCepigual(
        cepSemHifen === cepInstalacaoSemHifen && cepSemHifen !== ''
          ? 'sim'
          : 'nao'
      );
    } else {
      setHasInvoice(false);
      setCepProjeto('');
      setCepigual('nao');
    }
  }, [julia_fatura]);

  const handleCepChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 5) {
      value = value.replace(/^(\d{5})(\d{0,3}).*/, '$1-$2');
    }
    setCep(value);
  };

  const handleTotalconsumoChange = (e) => {
    const value = e.target.value;
    setTotalconsumo(value.replace(/[^0-9,.]/g, '').replace(/,/, '.'));
  };

  const handleCepigualChange = (e) => {
    setCepigual(e.target.value);
  };

  const handleAction = async (actionType) => {
    setLoading(true);
    let url = '';
    let body = {};

    const cepProjetoSemHifen = cepProjeto.replace('-', '');

    if (actionType === 'aprovar') {
      url = '/webhook/aprovafaturajulia';
      body = {
        proposta: julia_fatura.proposta,
        jsonjulia: {
          ...julia_fatura,
          unidade,
          cep: cep.replace('-', ''),
          totalconsumo: parseFloat(totalconsumo),
          multaAtraso,
          avisodecorte,
          nome,
          concessionaria,
          cep_instalacao: cepProjetoSemHifen.replace('-', ''),
          cepigual: cepigual,
        },
      };
    } else if (actionType === 'declinar') {
      url = '/webhook/aprovafaturajulia';
      body = {
        proposta: julia_fatura.proposta,
        jsonjulia: {
          ...julia_fatura,
          unidade,
          cep: cep.replace('-', ''),
          totalconsumo: parseFloat(totalconsumo),
          multaAtraso,
          avisodecorte,
          nome,
          concessionaria,
          cep_instalacao: cepProjetoSemHifen.replace('-', ''),
          cepigual: cepigual,
        },
      };
    } else if (actionType === 'removerFatura') {
      url = '/webhook/declinafaturajulia';
      body = {
        proposta: julia_fatura.proposta,
      };
    }

    try {
      await POST(url, body, true);
      onClose({ isSubmit: false });
      reloadContent?.();
    } catch (error) {
      console.error(`Erro na ação '${actionType}':`, error);
      toast.error('Ocorreu um erro ao processar a ação. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = () => {
    if (!unidade || !cep || !totalconsumo) {
      toast.error('Preencha todos os campos obrigatórios.');
      return;
    }
    handleAction('aprovar');
  };

  const handleRemoveInvoice = () => {
    handleAction('removerFatura');
  };

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalHeader>
          <h2>
            Análise Fatura Julia (Proposta: {julia_fatura?.proposta || 'N/A'})
          </h2>
          <CloseButton onClick={() => onClose({ isSubmit: false })}>
            &times;
          </CloseButton>
        </ModalHeader>
        <ModalBody>
          <InputFieldContainer>
            <InputLabel>Concessionaria</InputLabel>
            <Input
              value={concessionaria}
              onChange={(e) => setconcessionaria(e.target.value)}
            />
            <InputLabel>Unidade Consumidora</InputLabel>
            <Input
              value={unidade}
              onChange={(e) => setUnidade(e.target.value)}
            />
            <InputLabel>Cep Fatura</InputLabel>
            <Input
              type="text"
              value={cep}
              onChange={handleCepChange}
              maxLength="9"
              placeholder="00000-000"
            />
            <InputLabel>Cep Projeto</InputLabel>
            <Input
              type="text"
              value={cepProjeto}
              readOnly
              disabled={true}
              maxLength="9"
              placeholder="00000-000"
              style={{ background: '#f5f5f5', cursor: 'not-allowed' }}
            />
            <InputLabel>Consumo Total (kWh)</InputLabel>
            <Input value={totalconsumo} onChange={handleTotalconsumoChange} />
            <InputLabel>Multa por Atraso</InputLabel>
            <RadioButtonContainer>
              <label>
                <input
                  type="radio"
                  name="multaAtraso"
                  value="Sim"
                  checked={multaAtraso === 'Sim'}
                  onChange={(e) => setMultaAtraso(e.target.value)}
                />
                Sim
              </label>
              <label>
                <input
                  type="radio"
                  name="multaAtraso"
                  value="Não"
                  checked={multaAtraso === 'Não'}
                  onChange={(e) => setMultaAtraso(e.target.value)}
                />
                Não
              </label>
            </RadioButtonContainer>
            <InputLabel>Aviso de Corte</InputLabel>
            <RadioButtonContainer>
              <label>
                <input
                  type="radio"
                  name="avisodecorte"
                  value="Sim"
                  checked={avisodecorte === 'Sim'}
                  onChange={(e) => setAvisodecorte(e.target.value)}
                />
                Sim
              </label>
              <label>
                <input
                  type="radio"
                  name="avisodecorte"
                  value="Não"
                  checked={avisodecorte === 'Não'}
                  onChange={(e) => setAvisodecorte(e.target.value)}
                />
                Não
              </label>
            </RadioButtonContainer>
            <InputLabel>Nome confere com a fatura?</InputLabel>
            <RadioButtonContainer>
              <label>
                <input
                  type="radio"
                  name="nome"
                  value="sim"
                  checked={nome === 'sim'}
                  onChange={(e) => setNome(e.target.value)}
                />
                Sim
              </label>
              <label>
                <input
                  type="radio"
                  name="nome"
                  value="nao"
                  checked={nome === 'não' || nome === 'nao'}
                  onChange={(e) => setNome(e.target.value)}
                />
                Não
              </label>
            </RadioButtonContainer>
            <InputLabel>Os Cep são iguais?</InputLabel>
            <RadioButtonContainer>
              <label>
                <input
                  type="radio"
                  name="cepigual"
                  value="sim"
                  checked={cepigual === 'sim'}
                  onChange={handleCepigualChange}
                />
                Sim
              </label>
              <label>
                <input
                  type="radio"
                  name="cepigual"
                  value="nao"
                  checked={cepigual === 'nao'}
                  onChange={handleCepigualChange}
                />
                Não
              </label>
            </RadioButtonContainer>
          </InputFieldContainer>
          <JsonScrollContainer>
            <SubHeader>Detalhes da Fatura (JSON)</SubHeader>
            {hasInvoice && julia_fatura ? (
              <JsonObjectContainer>
                {Object.entries(julia_fatura).map(([key, value]) => (
                  <JsonNode key={key} label={key} value={value} />
                ))}
              </JsonObjectContainer>
            ) : (
              <NoInvoiceMessage>Nenhuma fatura anexada.</NoInvoiceMessage>
            )}
          </JsonScrollContainer>
        </ModalBody>
        <ModalFooter>
          {hasInvoice && (
            <Button
              onClick={handleRemoveInvoice}
              color="orange"
              loading={loading}
              disabled={loading}
            >
              Remover Fatura
            </Button>
          )}
          <Button
            onClick={handleApprove}
            color="blue"
            border
            loading={loading}
            disabled={loading}
          >
            Aprovar Julia
          </Button>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  );
};

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: #ffffff;
  color: #000000;
  padding: 30px;
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  height: 80%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  position: relative;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 15px;
  margin-bottom: 20px;
  h2 {
    color: #0077ff;
    margin: 0;
    font-size: 26px;
    font-weight: 600;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 36px;
  font-weight: lighter;
  color: #000000;
  cursor: pointer;
  line-height: 1;
  transition: color 0.2s;
  &:hover {
    color: #666666;
  }
`;

const ModalBody = styled.div`
  padding: 0;
  font-family: 'Segoe UI', 'Roboto', 'Arial', sans-serif;
  font-size: 16px;
  line-height: 1.7;
  flex-grow: 1;
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 30px;
  overflow-y: hidden;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  flex-shrink: 0;
`;

const InputFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow-y: auto;
`;

const InputLabel = styled.label`
  display: block;
  font-weight: 600;
  margin-bottom: 5px;
  color: #333;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
  &:disabled {
    background: #f5f5f5;
    cursor: not-allowed;
  }
`;

const RadioButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  label {
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: normal;
  }
`;

const LineHeader = styled.div`
  display: flex;
  align-items: center;
`;

const JsonLine = styled.div`
  margin-left: 25px;
  border-left: 1px dashed #cccccc;
  padding-left: 12px;
`;

const ExpandButton = styled.button`
  background: none;
  border: none;
  color: #0077ff;
  font-size: 1.4em;
  font-weight: bold;
  cursor: pointer;
  padding: 0 5px;
  line-height: 1;
  margin-right: 5px;
  &:focus {
    outline: none;
  }
`;

const Spacer = styled.div`
  width: 1.5em;
`;

const JsonLabel = styled.span`
  color: #000000;
  font-weight: 600;
  margin-right: 5px;
`;

const JsonType = styled.span`
  color: #999999;
  font-style: italic;
  margin-left: 5px;
`;

const JsonString = styled.span`
  color: #004d40;
`;

const JsonNumber = styled.span`
  color: #1a237e;
`;

const JsonBoolean = styled.span`
  color: #1a237e;
`;

const JsonNull = styled.span`
  color: #757575;
`;

const JsonDefault = styled.span`
  color: #000000;
`;

const JsonObjectContainer = styled.div`
  padding-left: 0;
`;

const JsonArrayContainer = styled.div`
  padding-left: 0;
`;

const NoInvoiceMessage = styled.div`
  text-align: center;
  padding: 20px;
  color: #999;
  font-style: italic;
  border: 1px dashed #ddd;
  border-radius: 8px;
`;

const JsonScrollContainer = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 0 5px;
  border-left: 1px solid #f0f0f0;
  padding-left: 30px;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const SubHeader = styled.h3`
  font-size: 18px;
  color: #555;
  margin-bottom: 15px;
`;

export default ModalAnaliseJulia;
